<section>
  <header>
    <h1>Transmissão</h1>
    <i icon="close" class="icon-close" (click)="chance('no')"></i>
  </header>

  <div class="card_bids" *ngIf="!loading">
    <div class="title_bid" *ngIf="transactions.id">
      <b class="h3card">Leilão {{ transactions?.name || '-' }}</b> <br>
      <span *ngIf="transactions?.transaction?.animal?.id">
        Lote:
        {{ transactions?.transaction?.animal?.lot || '-' }}
        -
        {{ transactions?.transaction?.animal.name || (transactions?.transaction?.animal.animal || '-')  }}
      </span>
    </div>
    <div class="title_bid" *ngIf="!transactions">
      Não há leilões com lances abertos no momento.
    </div>
  </div>

  <div
    class="row"
    style="width: 100%"
    *ngIf="!loading && transactions && transactions?.id && transactions?.transaction?.animal?.id"
  >
    <button
      mat-button
      class="primary"
      (click)="goToRealTime(transactions.id)"
    >
      Vídeos e Fotos do Lote
    </button>

    <!-- <app-super-bid-button
      *ngIf="animal_obj?.super_bid && animal_obj?.status !== 'VENDIDO' && !analizing_bid && animal_obj.schedule_event.enable_site_real_time"
      [animal_obj]="animal_obj"
    ></app-super-bid-button> -->

    <app-card-to-bid
      *ngIf="!bid_auction_loading && transactions.transaction.status !== 'CLOSED'"
      [is_live]="'LIVE'"
      [bid_type]="'VIRTUAL'"
      (eventCardToBidSocket)="eventSocket($event)"
    ></app-card-to-bid>

    <div class="no_items_found" *ngIf="!bid_auction_loading && transactions.transaction.status === 'CLOSED'">
      Aguarde os lances serem liberados
    </div>
  </div>

  <div *ngIf="!transactions?.transaction?.animal?.id">
    Nenhuma lote disponivel no momento! <br>
    Aguarde.
  </div>

  <div
    class="no_items_found"
    *ngIf="!loading && (!transactions.id || transactions.length <= 0)"
  >
    Nenhuma transmissão ao vivo no momento!
  </div>

  <page-loading *ngIf="loading"></page-loading>
</section>
